export const GIT_COMMIT = '44c27f5a8a5ebfb3c7a3b5d476ac5b2bbd41e56c';
